import agentHome from '@/views/agent/agentHome/index.vue'
import workbench from '@/views/agent/workbench/index.vue'
import agentProject from '@/views/agent/agentProject/index.vue'
import financeManagement from '@/views/agent/financeManagement/index.vue'
import earnestMoneyCheck from '@/views/agent/EarnestMoney/check.vue'
import earnestMoneyRefund from '@/views/agent/EarnestMoney/refund.vue'
import announcementAudit from '@/views/agent/announcementAudit/index.vue'
import candidateAudit from '@/views/agent/candidateAudit/index.vue'
import resultAudit from '@/views/agent/resultAudit/index.vue'
import noticeAudit from '@/views/agent/noticeAudit/index.vue'
import auditStatusModify from '@/views/agent/auditStatusModify/index.vue'
import bidderRegistrationAudit from '@/views/agent/bidderRegistrationAudit/index.vue'
import caBinding from '@/views/agent/caBinding/index.vue'
import agentorganizationModify from '@/views/agent/organizationModify/index.vue'
import semiProcess from '@/views/agent/semiProcess/index.vue'
import openTendering from '@/views/agent/openTendering/index.vue'
import competitiveNegotiation from '@/views/agent/competitiveNegotiation/index.vue'
import competitiveConsultation from '@/views/agent/competitiveConsultation/index.vue'
import invitationTendering from '@/views/agent/invitationTendering/index.vue'
import inquiryProcurement from '@/views/agent/inquiryProcurement/index.vue'
import singleSource from '@/views/agent/singleSource/index.vue'
import clarification from '@/views/agent/agentChild/clarification.vue'
import addTender from '@/views/agent/agentChild/addTender.vue'
import politicsProjectFlow from '@/views/agent/agentChild/politicsProjectFlow.vue'
import valuationbefore from '@/views/agent/agentChild/valuationbefore.vue'
import politicsProjectCreate from '@/views/agent/agentChild/politicsProjectCreate.vue'
import politicsProjectManage from '@/views/agent/agentChild/politicsProjectManage.vue'
import biddingPlan from '@/views/agent/agentChild/biddingPlan.vue'
import biddingPlanAdd from '@/views/agent/agentChild/biddingPlanAdd.vue'
import pioneerList from '@/views/agent/agentChild/pioneerList.vue'
import tenderProMgmt from '@/views/agent/agentChild/tenderProMgmt.vue'
import creatBidFile from '@/views/agent/agentChild/creatBidFile.vue'
import uploadBidFile from '@/views/agent/agentChild/uploadBidFile.vue'
import detailUploadFile from '@/views/agent/agentChild/detailUploadFile.vue'
import qualificationReview from '@/views/agent/agentChild/qualificationReview.vue'
import winningBidAnnouncement from '@/views/agent/agentChild/winningBidAnnouncement.vue'
import addBidNotice from '@/views/agent/agentChild/addBidNotice.vue'
import bidEvaluationMethod from '@/views/agent/bidEvaluation/bidEvaluationMethod.vue'
import bidEvaluationMethodList from '@/views/agent/agentChild/bidEvaluationMethodList.vue'
import bidOpeningHall from '@/views/agent/agentChild/bidOpeningHall.vue'
import judgeInfoEntry from '@/views/agent/agentChild/judgeInfoEntry.vue'
import bidResultNotification from '@/views/agent/agentChild/bidResultNotification.vue'
import publishTenderAnnouncement from '@/views/agent/agentChild/publishTenderAnnouncement.vue'
import addTenderAnnouncement from '@/views/agent/agentChild/addTenderAnnouncement.vue'
import bidOpeningSummary from '@/views/agent/agentChild/bidOpeningSummary.vue'
import printReviewResults from '@/views/agent/agentChild/printReviewResults.vue'
import stepRealTimeReview from '@/views/agent/agentChild/stepRealTimeReview.vue'
import qualificationReviewList from '@/views/agent/agentChild/qualificationReviewList.vue'
import evaluationReport from '@/views/agent/agentChild/evaluationReport.vue'
import addEvaluationReport from '@/views/agent/agentChild/addEvaluationReport.vue'
import tenderDocumentClarification from '@/views/agent/agentChild/tenderDocumentClarification.vue'
import calculateBidScore from '@/views/agent/agentChild/calculateBidScore.vue'
import expertQuestionView from '@/views/agent/agentChild/expertQuestionView.vue'
import oneClickArchive from '@/views/agent/agentChild/oneClickArchive.vue'
import answerBidderQuestions from '@/views/agent/agentChild/answerBidderQuestions.vue'
import exportBidAnalysis from '@/views/agent/agentChild/exportBidAnalysis.vue'
import bidTermination from '@/views/agent/agentChild/bidTermination.vue'
import bidComplaint from '@/views/agent/agentChild/bidComplaint.vue'
import openHall from '@/views/agent/agentChild/openHall.vue'
import expertExtraction from '@/views/agent/agentChild/expertExtraction.vue'
import expertInfoMaintenance from '@/views/agent/agentChild/expertInfoMaintenance.vue'
import expertExtractionAudit from '@/views/agent/agentChild/expertExtractionAudit.vue'
import singleSourceCreate from '@/views/agent/agentChild/singleSourceCreate.vue'
import newSingleSource from '@/views/agent/agentChild/newSingleSource.vue'
import expertExtractionList from '@/views/agent/agentChild/expertExtractionList.vue'
import expertExtractionFrom from '@/views/agent/agentChild/expertExtractionFrom.vue'
import semiProcessChild from '@/views/agent/semiProcessChild/index.vue'
import addProject from '@/views/agent/semiProcessChild/addProject.vue'
import projectWorkflow from '@/views/agent/semiProcessChild/projectWorkflow.vue'
import bidAnnouncementPublish from '@/views/agent/semiProcessChild/bidAnnouncementPublish.vue'
import candidatePublicity from '@/views/agent/semiProcessChild/candidatePublicity.vue'
import bidWinAnnouncement from '@/views/agent/semiProcessChild/bidWinAnnouncement.vue'
import winningBidCandidates from '@/views/agent/agentChild/winningBidCandidates.vue'
import contract from '@/views/agent/agentChild/contract.vue'
import contractAdd from '@/views/agent/agentChild/contractAdd.vue'

// 通用子页面（政府/建设工程/竞争性磋商均复用）
const commonAgentChildren = [
  { path: 'addTender', name: 'addTender', component: addTender },
  { path: 'politicsProjectFlow', name: 'politicsProjectFlow', component: politicsProjectFlow },
  { path: 'politicsProjectCreate', name: 'politicsProjectCreate', component: politicsProjectCreate },
  { path: 'politicsProjectManage', name: 'politicsProjectManage', component: politicsProjectManage },
  { path: 'tenderProMgmt', name: 'tenderProMgmt', component: tenderProMgmt },
  { path: 'creatBidFile', name: 'creatBidFile', component: creatBidFile },
  { path: 'uploadBidFile', name: 'uploadBidFile', component: uploadBidFile },
  { path: 'detailUploadFile', name: 'detailUploadFile', component: detailUploadFile },
  { path: 'qualificationReview', name: 'qualificationReview', component: qualificationReview },
  { path: 'winningBidAnnouncement', name: 'winningBidAnnouncement', component: winningBidAnnouncement },
  { path: 'bidEvaluationMethodList', name: 'bidEvaluationMethodList', component: bidEvaluationMethodList },
  { path: 'addBidNotice', name: 'addBidNotice', component: addBidNotice },
  { path: 'bidOpeningHall', name: 'bidOpeningHall', component: bidOpeningHall },
  { path: 'judgeInfoEntry', name: 'judgeInfoEntry', component: judgeInfoEntry },
  { path: 'bidResultNotification', name: 'bidResultNotification', component: bidResultNotification },
  { path: 'publishTenderAnnouncement', name: 'publishTenderAnnouncement', component: publishTenderAnnouncement },
  { path: 'addTenderAnnouncement', name: 'addTenderAnnouncement', component: addTenderAnnouncement },
  { path: 'bidOpeningSummary', name: 'bidOpeningSummary', component: bidOpeningSummary },
  { path: 'printReviewResults', name: 'printReviewResults', component: printReviewResults },
  { path: 'stepRealTimeReview', name: 'stepRealTimeReview', component: stepRealTimeReview },
  { path: 'qualificationReviewList', name: 'qualificationReviewList', component: qualificationReviewList },
  { path: 'evaluationReport', name: 'evaluationReport', component: evaluationReport },
  { path: 'addEvaluationReport', name: 'addEvaluationReport', component: addEvaluationReport },
  { path: 'tenderDocumentClarification', name: 'tenderDocumentClarification', component: tenderDocumentClarification },
  { path: 'calculateBidScore', name: 'calculateBidScore', component: calculateBidScore },
  { path: 'expertQuestionView', name: 'expertQuestionView', component: expertQuestionView },
  { path: 'oneClickArchive', name: 'oneClickArchive', component: oneClickArchive },
  { path: 'answerBidderQuestions', name: 'answerBidderQuestions', component: answerBidderQuestions },
  { path: 'exportBidAnalysis', name: 'exportBidAnalysis', component: exportBidAnalysis },
  { path: 'bidTermination', name: 'bidTermination', component: bidTermination },
  { path: 'bidComplaint', name: 'bidComplaint', component: bidComplaint },
  { path: 'singleSourceCreate', name: 'singleSourceCreate', component: singleSourceCreate },
  { path: 'newSingleSource', name: 'newSingleSource', component: newSingleSource },
  { path: 'expertExtractionFrom', name: 'expertExtractionFrom', component: expertExtractionFrom },
  { path: 'semiProcessChild', name: 'semiProcessChild', component: semiProcessChild },
  { path: 'addProject', name: 'addProject', component: addProject },
  { path: 'projectWorkflow', name: 'projectWorkflow', component: projectWorkflow },
  { path: 'bidAnnouncementPublish', name: 'bidAnnouncementPublish', component: bidAnnouncementPublish },
  { path: 'candidatePublicity', name: 'candidatePublicity', component: candidatePublicity },
  { path: 'bidWinAnnouncement', name: 'bidWinAnnouncement', component: bidWinAnnouncement },
  { path: 'winningBidCandidates', name: 'winningBidCandidates', component: winningBidCandidates },
  { path: 'valuationbefore', name: 'valuationbefore', component: valuationbefore },
  { path: 'biddingPlan', name: 'biddingPlan', component: biddingPlan },
  { path: 'biddingPlanAdd', name: 'biddingPlanAdd', component: biddingPlanAdd },
  { path: 'pioneerList', name: 'pioneerList', component: pioneerList },
  { path: 'contract', name: 'contract', component: contract },
  { path: 'contractAdd', name: 'contractAdd', component: contractAdd },
]

// 政府采购子页面（复用通用组件，路由名带 gov 前缀）
const govChildren = commonAgentChildren.map(route => ({
  ...route,
  path: 'gov' + route.path.charAt(0).toUpperCase() + route.path.slice(1),
  name: 'gov' + route.name.charAt(0).toUpperCase() + route.name.slice(1),
}))

// 建设工程子页面（复用通用组件，路由名带 construction 前缀）
const constructionChildren = commonAgentChildren.map(route => ({
  ...route,
  path: 'construction' + route.path.charAt(0).toUpperCase() + route.path.slice(1),
  name: 'construction' + route.name.charAt(0).toUpperCase() + route.name.slice(1),
}))

// 政府采购竞争性磋商子页面
const govCompetitiveConsultationChildren = commonAgentChildren.map(route => ({
  ...route,
  path: 'govCompetitiveConsultation' + route.path.charAt(0).toUpperCase() + route.path.slice(1),
  name: 'govCompetitiveConsultation' + route.name.charAt(0).toUpperCase() + route.name.slice(1),
}))

export default [
  {
    path: '/agentHome',
    component: agentHome,
    redirect: '/agentHome/workbench',
    children: [
      { path: 'agentProject', name: 'agentProject', component: agentProject },
      { path: 'workbench', name: 'workbench', component: workbench },
      // 企业采购模块
      { path: 'openTendering', name: 'openTendering', component: openTendering },
      { path: 'competitiveNegotiation', name: 'competitiveNegotiation', component: competitiveNegotiation },
      { path: 'competitiveConsultation', name: 'competitiveConsultation', component: competitiveConsultation },
      { path: 'invitationTendering', name: 'invitationTendering', component: invitationTendering },
      { path: 'inquiryProcurement', name: 'inquiryProcurement', component: inquiryProcurement },
      { path: 'singleSource', name: 'singleSource', component: singleSource },
      { path: 'clarification', name: 'clarification', component: clarification },
      // 政府采购模块（复用企业采购组件）
      { path: 'govOpenTendering', name: 'govOpenTendering', component: openTendering },
      { path: 'govCompetitiveNegotiation', name: 'govCompetitiveNegotiation', component: competitiveNegotiation },
      { path: 'govCompetitiveConsultation', name: 'govCompetitiveConsultation', component: competitiveConsultation },
      { path: 'govInvitationTendering', name: 'govInvitationTendering', component: invitationTendering },
      { path: 'govInquiryProcurement', name: 'govInquiryProcurement', component: inquiryProcurement },
      { path: 'govSingleSource', name: 'govSingleSource', component: singleSource },
      // 建设工程模块（复用企业采购组件）
      { path: 'constructionOpenTendering', name: 'constructionOpenTendering', component: openTendering },
      // 财务管理模块
      { path: 'financeManagement', name: 'financeManagement', component: financeManagement },
      { path: 'earnestMoneyCheck', name: 'earnestMoneyCheck', component: earnestMoneyCheck },
      { path: 'earnestMoneyRefund', name: 'earnestMoneyRefund', component: earnestMoneyRefund },
      // 综合管理模块
      { path: 'announcementAudit', name: 'announcementAudit', component: announcementAudit },
      { path: 'candidateAudit', name: 'candidateAudit', component: candidateAudit },
      { path: 'resultAudit', name: 'resultAudit', component: resultAudit },
      { path: 'noticeAudit', name: 'noticeAudit', component: noticeAudit },
      { path: 'auditStatusModify', name: 'auditStatusModify', component: auditStatusModify },
      { path: 'bidderRegistrationAudit', name: 'bidderRegistrationAudit', component: bidderRegistrationAudit },
      // 专家管理模块
      { path: 'expertInfoMaintenance', name: 'expertInfoMaintenance', component: expertInfoMaintenance },
      { path: 'expertExtractionAudit', name: 'expertExtractionAudit', component: expertExtractionAudit },
      { path: 'expertExtraction', name: 'expertExtraction', component: expertExtraction },
      { path: 'expertExtractionList', name: 'expertExtractionList', component: expertExtractionList },
      // 系统管理模块
      { path: 'caBinding', name: 'caBinding', component: caBinding },
      { path: 'agentorganizationModify', name: 'agentorganizationModify', component: agentorganizationModify },
      // 半流程模块
      { path: 'semiProcess', name: 'semiProcess', component: semiProcess },
      // 通用子页面
      ...commonAgentChildren,
      // 政府采购子页面
      ...govChildren,
      // 建设工程子页面
      ...constructionChildren,
      // 政府采购竞争性磋商子页面
      ...govCompetitiveConsultationChildren,
    ]
  },
]
